import React from 'react';
import {motion} from 'framer-motion';
import {Link as RouterLink} from 'react-router-dom';
import {Box, Button, Container, Typography} from '@mui/material';
import {MotionContainer, varBounceIn} from '@/components/animate';

export default function NotFound(): any {
    return (
        <Container
            sx={{
                direction: "row",
                justifyContent: "center",
                alignItems: "center",
                display: 'flex',
                pt: 0,
                pb: 0,
                height: '100vh'
            }}
        >
            <MotionContainer initial="initial" open>
                <Box sx={{maxWidth: 480, margin: 'auto', textAlign: 'center'}}>
                    <motion.div variants={varBounceIn}>
                        <Typography variant="h3" paragraph>
                            Sorry, page not found!
                        </Typography>
                    </motion.div>
                    <Typography sx={{color: 'text.secondary'}}>
                        Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL?
                        Be sure to check your spelling.
                    </Typography>

                    <motion.div variants={varBounceIn}>
                        <Box
                            component="img"
                            src="/static/illustrations/illustration_404.svg"
                            sx={{height: 260, mx: 'auto', my: {xs: 5, sm: 10}, filter: 'invert(28%) sepia(99%) saturate(384%) hue-rotate(160deg) brightness(94%) contrast(87%)'}}
                        />
                    </motion.div>

                    <Button to="/" size="large" variant="contained" component={RouterLink}>
                        Go to Home
                    </Button>
                </Box>
            </MotionContainer>
        </Container>
    );
}
